import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--view-more",
  "use": "icon-arrow--view-more-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 8 8\" id=\"icon-arrow--view-more\"><path d=\"M2.181 0a.727.727 0 1 0 0 1.456H5.5L.212 6.76a.727.727 0 0 0 1.03 1.026l5.304-5.313v3.343a.727.727 0 1 0 1.454 0V.726A.727.727 0 0 0 7.27 0H2.181Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol